<template>
  <ToastRack :position="position" :is-static="true">
    <Toaster 
      :local-show="localShow"
      :title="title"
      :on-close="onClose"
      :variant="variant"
      :colour="colour"
    >
      <slot></slot>
    </Toaster>
  </ToastRack>
</template>

<script>
  import ToastRack from './toast-rack.vue'
  import Toaster from './toaster.vue'

  export default {
    name: 'FabricToast',
    components: {
      ToastRack,
      Toaster,
    },
    props: {
      position: {
        type: String,
        default: 'top-right'
      },
      id: {
        type: [String],
        default: '',
      },
      title: {
        type: [String],
        default: '',
      },
      variant: {
        type: [String, Boolean],
        default: 'success'
      },
      colour: {
        type: [String],
        default: 'green'
      },
    },
    data() {
      return {
        localShow: false,
      }
    },
    mounted() {
      this.$root.$on('event-toast-show', dataEvent => {
        const { id, options } = dataEvent
        const toastItems = [...document.querySelectorAll('.toaster-item')];
        toastItems.map(toastItem => toastItem.remove())
        if (id === this.id) {
          this.localShow = true
          if(options.timer) {
            setTimeout(() => {
              this.localShow = false
            }, options.timer)
          }
        } else {
          this.onClose()
        }
      })
      this.$root.$on('event-static-show', dataEvent => {
        this.onClose()
      })
    },
    methods: {
      onClose() {
        this.localShow = false
      },
    },
  }
</script>
